<template>
  <div class="company">
    <div class="about-img">
      <img src="../assets/img/bg.jpg" width="650" height="400" alt="company">
    </div>
    <h2>

      HUBEI RCH<br>
      ENTERPRISE CO.,LTD
    </h2>
    <p>
      Hubei RCH Enterprise Co.,Limited is a professional underwater equipment manufacturer, headquartered in Yichang, Hubei, the capital of hydropower in China. The company has a R&D center and production factory in Jiangsu, integrating R&D, manufacturing and sales, with business scope all over the country and overseas.
    </p>
    <p>
      We are committed to providing customers with high-quality, high-reliability and sustainable solutions to meet the changing needs of the industry. After years of development and exploration, the company has successfully launched a series of independently developed deep-sea equipment, including underwater cameras, underwater video accessories, underwater illumination, underwater gimbal, underwater pan/tilts, underwater optical transceivers, underwater connectors, underwater manipulators, underwater laser, underwater propellers, underwater robots etc., and have been successfully used in scientific research, offshore resource exploration, fisheries, security and water conservancy projects. The company has passed ISO9001:2015 quality management system certification, and always adheres to technological innovation, insists on making in China, and serves the country and the world.
    </p>
    <p>
      Our vision is to become one of the world's most trusted companies, creating lasting value for customers, employees and society. We will achieve this vision by continuously improving our technology research and development capabilities, expanding our market share and strengthening our partnerships. We firmly believe that through unity, innovation and sense of responsibility, we will continue to promote the development of the enterprise and make positive contributions to society.
    </p>
  </div>
</template>

<script setup lang="ts">

</script>

<style lang="stylus" scoped>
.company
  max-width: 1510px;
  min-width: 1280px;
  margin: 0 auto 30px;
  padding: 40px 50px 0;
  box-sizing: border-box;
  overflow hidden
  h2
    font-size 36px
    color #333333
    line-height 42px
    font-weight 600
    margin-bottom 16px
  p
    font-size 18px
    color #666666
    line-height 38px
    text-align justify
    font-weight 300
  .about-img
    float right
    position relative
    margin-right 30px
    margin-top 5px
    &:before
      content ''
      display inline-block
      width 500px
      height 275px
      background #398da6
      position absolute
      bottom -25px
      right -25px
      z-index -1
    &>img
      margin-left 24px
</style>
